import { render, staticRenderFns } from "./ContentTypeFieldsetsList.vue?vue&type=template&id=3ee1086c&scoped=true"
import script from "./ContentTypeFieldsetsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentTypeFieldsetsList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ContentTypeFieldsetsList.vue?vue&type=style&index=0&id=3ee1086c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee1086c",
  null
  
)

export default component.exports